// Durante o deploy, o core anterior ainda envia inteiros; o novo conserva o número dos autos.
export function numeroDoEventoOuNulo(valor: unknown): string | null {
  if (typeof valor === 'number') {
    return Number.isSafeInteger(valor) && valor >= 0 ? String(valor).padStart(2, '0') : null;
  }
  if (typeof valor !== 'string') return null;
  const texto = valor.trim();
  return /^\d+$/.test(texto) ? texto : null;
}
